import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import { CustomButton, CustomReactSelect } from '../../../shared';
import { Trash, DownloadIcon, Upload } from '../../../../assets';
import { useDispatch, useSelector } from 'react-redux';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import { creativeUploadActions } from '../../../../redux/reducers/creativeUploadReducer';
import { downloadFiles } from '../../../../utility';
import ConfirmationDelete from '../confirmationDelete';
import { toast } from 'react-toastify';
import { deleteCreative, getCreatives } from '../../../../redux/thunks/creativeUploadThunk';

const FilterBar = (props) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const { companyOptions, company: selectedCompany } = useSelector(
        (state) => state.company
    );
    const { creatives, selectedCreatives } = useSelector((state) => state.creativeUpload);
    const { setCompany } = companyActions;

    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
    };
    const handleDownload = () => {
        if (!selectedCreatives.length) {
            toast.error('Please select at least one file to download!!');
        } else {
            const filesToDownload = selectedCreatives
                .map((id) => {
                    const fileDetails = creatives?.find((file) => file.id === id);
                    return fileDetails
                        ? {
                            file_url: fileDetails.file_path,
                            file_name: fileDetails.creative_name
                        }
                        : null;
                })
                .filter((file) => file);
            downloadFiles(filesToDownload);
            dispatch(creativeUploadActions.handleSelected({ type: 'unselect' }));
        }
    };

    const handleDeleteOpen = () => {
        if (!selectedCreatives.length)
            toast.error('Please select at least one file to delete!!');
        else setOpen(true);
    };
    const handleDeleteSelected = () => {
        if (selectedCreatives.length > 0) {
            dispatch(
                deleteCreative({
                    companyId: selectedCompany.id,
                    data: { ids: selectedCreatives }
                })
            ).then((result) => {
                if (result.payload.status_code === 200) {
                    dispatch(creativeUploadActions.setSelectedAllFalse());
                    dispatch(
                        creativeUploadActions.handleSelected({ type: 'unselect' })
                    );
                    dispatch(getCreatives({ companyId: selectedCompany.id }));
                    onclose();
                }
            });
        }
    };

    const onclose = () => {
        setOpen(!open);
    };

    const handleCreate = ()=>{
        dispatch(creativeUploadActions.resetCreative());
        dispatch(creativeUploadActions.handleUploadModal({ type: 'create' }));
    };

    return (
        <>
            <Grid container className="flex-row-space-between pb-24px mt-10px" xs={12}>
                <Grid item className="d-flex gap-12" xs={6}>
                    {/* Select Inputs */}
                    <Box className="flex-row gap-12">
                        <Box width={300}>
                            <CustomReactSelect
                                customStyle={{ borderRadius: '50px' }}
                                handleFilter={handleCompanyChange}
                                options={companyOptions}
                                placeholder="Select Company"
                                selectedOption={{
                                    label: selectedCompany.name,
                                    value: selectedCompany.id
                                }}
                            />
                        </Box>
                    </Box>
                </Grid>
                <Grid item className="d-flex gap-12" xs={6}>
                    <CustomButton
                        buttonColor="#AD509E"
                        handleClick={() =>handleCreate()}
                        icon={<Upload color="#FFFFFF" />}
                        title="Create Creative"
                        titleColor="#FFFFFF"
                    />
                    <CustomButton
                        buttonColor="#AD509E"
                        handleClick={handleDownload}
                        icon={<DownloadIcon color="#FFFFFF" />}
                        title="Download Creatives"
                        titleColor="#FFFFFF"
                    />
                    <CustomButton
                        handleClick={() => handleDeleteOpen()}
                        icon={<Trash />}
                        title="Delete Creatives"
                    />
                </Grid>
            </Grid>
            <ConfirmationDelete
                open={open}
                onClosed={onclose}
                onConfirms={handleDeleteSelected}
            />
        </>
    );
};

export default FilterBar;
